/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnDesktopPlatform } from './en-desktop-platform';
 /**
 *
 *
 * @export
 * @interface RegisterStationDto
 */
export interface RegisterStationDto {

    /**
     * @type {string}
     * @memberof RegisterStationDto
     */
    ksn: string;

    /**
     * Human-readable name for the kiosk (e.g. \"Kiosk Floor 2 - Room 4\")
     *
     * @type {string}
     * @memberof RegisterStationDto
     */
    name: string;

    /**
     * Hardware identifier (e.g. motherboard serial, BIOS UUID)
     *
     * @type {string}
     * @memberof RegisterStationDto
     */
    deviceId: string;

    /**
     * @type {EnDesktopPlatform}
     * @memberof RegisterStationDto
     */
    platform: EnDesktopPlatform;

    /**
     * OS version (e.g. \"Windows 11 23H2\", \"Ubuntu 24.04\", \"macOS 14.4\")
     *
     * @type {string}
     * @memberof RegisterStationDto
     */
    systemVersion: string;

    /**
     * Unity app version (e.g. \"1.0.0\")
     *
     * @type {string}
     * @memberof RegisterStationDto
     */
    appVersion: string;

    /**
     * @type {string}
     * @memberof RegisterStationDto
     */
    publicKey: string;
}
